<template>
<div class="stay-period">
    <div class="text-center">
        <div class="month">{{ getMonth(check_in) }}</div>
        <div class="date">{{ getDay(check_in) }}</div>
    </div>
    <v-icon color="primary" size="16">play_arrow</v-icon>
    <div class="text-center">
        <div class="month">{{ getMonth(check_out) }}</div>
        <div class="date"> {{ getDay(check_out) }}</div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        check_in: String,
        check_out: String,
    },

    methods: {
        getMonth(date) {
            if(!date) return null

            return this.$moment(String(date))
                .format('MMM');

        },
        getDay(date) {
            if(!date) return null

            return this.$moment(String(date))
                .format('DD');
        },
    },

}
</script>

<style>
.stay-period {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
    max-width: 80px;
    margin: auto;
}

.stay-period .date {
    line-height: 14px;
    font-size: 13px;
    font-weight: 700;
}
</style>
